// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useContext, Fragment, createContext} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {App_context} from 'hola_app_context';
import {Settings_context} from '../settings_ctx';
import {Button} from '../../../shared/button';
import {Editor} from '../../../shared/editor/editor';
import {Modal} from '../../../shared/ui/modal';
import {Payment_form} from '../plus/payment_form_hola2023_theme';
import {Already_premium} from '../plus/already_premium';
import {use_translation_v} from '../lib/trans_v';
import styles from './plans_as_boxes.module.less';
import cn from 'classnames';
import {format_price} from 'zcountry';
import experiment_init from '../experiment_init';
// @ts-ignore
import _sortBy from 'lodash.sortby';
// @ts-ignore
import {get_price_plan}
    from '../../../../svc/account/pub/membership.js';
// @ts-ignore
import {get_plan_display_options}
    from '../../../../svc/vpn/pub/common_ui.js';
import plans_util from '/www/hola/pub/plans_util.js';
import {use_premium_page, plan_to_url}
    from '../ui/premium/use_premium_page';
import {i_plus_context_store, i_plan, i_plan_extended, i_plan_payment_info,
    i_plan_display_options} from '../plus/plus_types';

export type plan_label_type = 'best'|'popular'

const Plus_context = createContext<i_plus_context_store | null>(null);

type t_plus_store_provider_props = React.PropsWithChildren<{
    value: i_plus_context_store;
    key?: React.Key;
}>;

export const Plus_store_provider = ({children, value, ...props}:
    t_plus_store_provider_props)=>{
    const {best, popular} = plans_util.get_special_plans(value.plans);
    const provider_value = {
        ...value,
        best_id: best?.id,
        popular_id: popular?.id,
    };
    return <Plus_context.Provider {...props} value={provider_value}>{children}
      </Plus_context.Provider>;
};

export const use_plus_store = (): i_plus_context_store=>{
    const context = useContext(Plus_context);
    if (context === null)
    {
        throw new Error('use_plus_store should be called inside '
        +'Plus_store_provider!');
    }
    return context;
};

const get_plan_label_type = (store: i_plus_context_store, plan: i_plan):
    plan_label_type | undefined=>{
    if (store.plans.length < 2)
        return;
    if (plan.id === store.best_id)
        return 'best';
    if (plan.id === store.popular_id)
        return 'popular';
    return;
};

const plan_order_pred = (label_type: plan_label_type): number=>{
    const val = {best: 2, popular: 1};
    return val[label_type]||0;
};

const Plan_badge = ({type}: {type?: plan_label_type})=>{
    const {t} = use_translation_v({version: 0});
    const type_to_style = {
        best: {style: styles.best_value, text: t('Best Value')},
        popular: {style: styles.most_popular, text: t('Most popular')},
    };
    const {style, text} = type_to_style[type]||{};
    return <div className={styles.type_badge_container}>
      <p className={cn([styles.type_badge, style])}>{text}</p>
    </div>;
};

interface i_plan_pricing_section_props {
    plan: i_plan_extended;
    price_o: i_plan_payment_info;
    currency?: string;
}

const Plan_pricing_section = ({currency, plan, price_o}:
    i_plan_pricing_section_props)=>{
    const {every} = plan;
    const {price, regular_price} = price_o;
    const {theme} = useContext(Settings_context);
    const {T} = use_translation_v({version: 0});
    const {show_line_through_regular_price, show_renewal_billing_label}
        = get_plan_display_options(plan) as i_plan_display_options;
    const pricing_regular = show_line_through_regular_price
        ? <Fragment>
            <span className={styles.line_through}>
              {format_price(currency, regular_price)}
            </span>
            &nbsp;
            <span className={styles.price}>
              {format_price(currency, price)}
            </span>
        </Fragment> : null;
    const billed = show_renewal_billing_label
        ? <Fragment><T>for the first {every}</T><sup>*</sup></Fragment>
        : <T>billed every {every}</T>;
    return <div>
      <p className={cn([theme.xs, theme.color_n500])}>
        {pricing_regular}
      </p>
      <p className={cn([theme.xs, theme.color_n500])}>{billed}</p>
    </div>;
};

interface i_plan_box_props {
    plan: i_plan_extended;
    already_plus: boolean;
    with_payment_modal?: boolean;
    key?: React.Key;
    cta_text?: string;
}

const Plan_box = ({plan, cta_text, with_payment_modal = true, already_plus,
    ...props}: i_plan_box_props)=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const location = useLocation();
    const {t} = use_translation_v({version: 0});
    const plus_store = use_plus_store();
    const price_o = get_price_plan(plan, plus_store.currency);
    const {month_price, price} = price_o;
    const label_type = get_plan_label_type(plus_store, plan);
    const wrapper_cls = cn(styles.box_wrapper, styles[label_type]);
    const handle_select = ()=>{
        if (!with_payment_modal && !already_plus)
        {
            history.push(
              `${location.pathname}/checkout?plan=${plan_to_url(plan)}`);
            return;
        }
        plus_store.set_plan(plan);
        plus_store.open_payment_form();
  } ;
    return <div className={wrapper_cls}>
      <div className={styles.box_container} {...props} onClick={handle_select}>
        <div className={styles.period}>
          <p className={cn([theme.p3, theme.color_n700,
            theme.med, styles.period])}>
            {plan.short_name}
          </p>
          {label_type=='popular' ?
            <div className={styles.empty_div}/> :
            <Plan_badge type={label_type}/>}
        </div>
        <div className={styles.pricing}>
          <div className={styles.price}>
            {(month_price||price) && <div className={styles.monthly_price}>
              <h5 className={styles.monthly_value}>
                {format_price(plus_store.currency, month_price||price)}
              </h5>
              <p className={cn([theme.p5, theme.med, styles.billed_every,
                theme.color_n500])}>
                &nbsp;/&nbsp;{t(month_price ? 'month' : plan.every)}
              </p>
            </div>}
          </div>
          <Plan_pricing_section plan={plan} currency={plus_store.currency}
            price_o={price_o}/>
        </div>
        <div className={styles.btn_container}>
          <Button caption={cta_text || t('Select')}
            cls={styles.btn_select} color="transparent"/>
        </div>
      </div>
      <div className={styles.underlay}/>
    </div>;
};

interface i_plans_as_boxes_impl_props {
    with_payment_modal: boolean;
    already_plus: boolean;
    cta?: string;
    class_name?: string;
}
export const Plans_as_boxes_impl = (props: i_plans_as_boxes_impl_props)=>{
    const {cta, with_payment_modal = true, already_plus, class_name} = props;
    const plus_store = use_plus_store();
    const {plans} = plus_store;
    const ordered_plans = _sortBy(plans, plan=>{
        const label_type = get_plan_label_type(plus_store, plan);
        return plan_order_pred(label_type);
    });
    return <div className={cn(styles.root, class_name)}>
      <div className={styles.boxes_grid}>
        {ordered_plans.map(plan=><Plan_box key={plan.id} plan={plan}
          with_payment_modal={with_payment_modal} already_plus={already_plus}
          cta_text={cta}/>)}
      </div>
    </div>;
};

interface i_plans_as_boxes_props extends i_plus_context_store {
    cta: string;
    with_payment_modal?: boolean;
    key?: React.Key;
    class_name?: string;
}

export const Plans_as_boxes = ({cta, with_payment_modal = true,
    class_name}: i_plans_as_boxes_props)=>{
    const page = use_premium_page({from_bext: false});
    const {is_payment_form_open, already_plus, open_form, close_form,
        opt, is_mobile} = page;
    const {is_client, is_plus} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    return <Plus_store_provider value={{...page,
      open_payment_form: open_form}}>
      <Plans_as_boxes_impl cta={cta} already_plus={is_plus}
        with_payment_modal={with_payment_modal} class_name={class_name}/>
      <Fragment>
        {with_payment_modal &&
          <Modal is_open={is_payment_form_open && !already_plus}
            on_close={close_form} paddingless width={!is_client ? 0 :
            is_mobile ? 335 : 592}
            on_overlay_click={()=>undefined}
            cls={styles.modal_root} fixed_top={67}
            long_modal content_cls={styles.modal_content}>
              <Payment_form visible={is_payment_form_open}
                opt={opt} cls={styles.form_in_modal}
                all_plans_test={true}
                with_skeleton={!!experiment_init.ui_test.test_skeleton}
                payment_btn_on_top={true}/>
          </Modal>
        }
      </Fragment>
      <Fragment>
        {is_plus &&
          <Modal is_open={is_payment_form_open && is_plus}
            on_close={close_form} width={335} cls={theme.root}>
            <Already_premium on_click={close_form}/>
          </Modal>
        }
      </Fragment>
    </Plus_store_provider>;
};

interface i_plans_as_boxes_editor_props {
    value: {cta: string, with_payment_modal: boolean};
    on_change: (newValue: {cta: string, with_payment_modal: boolean})=>void;
}

export const Plans_as_boxes_editor =(props: i_plans_as_boxes_editor_props)=>{
    const {value, on_change} = props;
    return <Editor value={value} on_change={v=>on_change(v)}
      editors={[
        {key: 'with_payment_modal', label: 'With payment modal',
          type: 'boolean'},
          {key: 'cta', label: 'Buttons label', type: 'text'}
        ]}/>;
};
